let progress_bars = document.querySelectorAll(".progress");

progress_bars.forEach((element) => {
    let progress_width = element.firstElementChild.style.width;
    let test = parseInt(progress_width);
    test -= 0.4;
    element.previousElementSibling.style.paddingLeft = `${test}%`;
    element.previousElementSibling.firstElementChild.marginLeft = "-24px";
});
